module.exports = __webpack_public_path__ + "static/media/unlimited-changes.fe0d648e.svg";